import { USER_ONBOARD_ADMIN, USER_ONBOARD_ADMIN_LO, USER_ONBOARD_LOAN_OFFICER, USER_ONBOARD_LOAN_OFFICER_BACK_END, USER_ONBOARD_LOAN_PROCESSOR, USER_ONBOARD_UNDERWRITER } from "src/services/constants/accounts";
import { getNamespaceId } from "src/services/objects/namespaces";
import { ADMIN_LO_TABS, ADMIN_TABS, LOAN_PROCESSOR_TABS, LO_BACKEND_TABS, LO_TABS, UNDERWRITTER_TABS } from "./mortgageTabs";

export const getDefaultPipelineConfig = () => {
    const namespaceId = getNamespaceId();
    return [{
        namespaceId: namespaceId,
        role: USER_ONBOARD_ADMIN_LO,
        tabs: ADMIN_LO_TABS
    },
    {
        namespaceId: namespaceId,
        role: USER_ONBOARD_ADMIN,
        tabs: ADMIN_TABS
    },
    {
        namespaceId: namespaceId,
        role: USER_ONBOARD_LOAN_OFFICER,
        tabs: LO_TABS
    },
    {
        namespaceId: namespaceId,
        role: USER_ONBOARD_LOAN_PROCESSOR,
        tabs: LOAN_PROCESSOR_TABS
    },
    {
        namespaceId: namespaceId,
        role: USER_ONBOARD_LOAN_OFFICER_BACK_END,
        tabs: LO_BACKEND_TABS
    },
    {
        namespaceId: namespaceId,
        role: USER_ONBOARD_UNDERWRITER,
        tabs: UNDERWRITTER_TABS
    }];
    
} 